import { Component, Injector, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { TypeListMenu } from '../../enums/type-list-menu';
import { CompanyParamsService } from '../../services/company-params.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/shared/utils';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'is-what';
import { environment } from 'src/environments/environment';
import { NgIf, NgClass, NgStyle, NgFor, LowerCasePipe } from '@angular/common';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { HeartHeaderComponent } from '../../../shared/lista-deseos/heart-header/heart-header.component';
import { LogoutComponent } from '../logout/logout.component';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgIf, CustomHeaderComponent, NgClass, NgStyle, NgFor, HeartHeaderComponent, LogoutComponent, LowerCasePipe]
})
export class HeaderComponent extends BaseComponent implements OnInit {
  typeListMenu = TypeListMenu;
  renderMenu: boolean = false;
  company?: any;
  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  headerHeightInput: any;
  headerHeightInput1: any;
  mainColor: any;
  isDev: boolean = false;
  headerBackgroundcolor = '';
  renderTopHeader: boolean = false;
  @ViewChild('header') headerRef!: ElementRef;
  @ViewChild('header1') headerRef1!: ElementRef;
  menuHeaderConfiguration: any;
  topHeaderHeight: string = '0';
  topHeaderBackgroundColor: string = '#';
  topHeaderRRSSIcons: any;
  topHeaderContactIcons: any;
  topHeaderTemplate: string = '';
  topHeaderFontColor: string = '#';
  renderTopHeaderOnlyResponsive: boolean = false;
  isReponsive: boolean = false;
  innerWidth: any;

  constructor(
    public companyParamsService: CompanyParamsService,
    private injector: Injector,
    private activatedRoute: ActivatedRoute,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (isNullOrUndefined(this.companyParamsService.company)) {
      return;
    }
    this.company = isNullOrUndefined(this.companyParamsService.company.headerActions) ? "" : this.companyParamsService.company.headerActions.headerTemplate;
    this.renderMenu = isNullOrUndefined(this.company) || this.company === '';
    this.mainColor = this.companyParamsService.getMainColor();
    this.isDev = environment.production ? false : true;
    this.headerBackgroundcolor = this.companyParamsService.company.listadoMenu.length == 0 ? "" : this.companyParamsService.getListMenuOrdered()[0].headerStyle;
    this.menuHeaderConfiguration = this.companyParamsService.company.headerActions.menuHeaderConfiguration;
    this.renderTopHeader = !isNullOrUndefined(this.menuHeaderConfiguration);
    if (this.renderTopHeader) {
      this.topHeaderHeight = this.menuHeaderConfiguration.highMenuHeader;
      this.topHeaderBackgroundColor = '#' + this.menuHeaderConfiguration.colorMenuBackground;
      this.topHeaderRRSSIcons = this.menuHeaderConfiguration.rrssStyle;
      this.topHeaderContactIcons = this.menuHeaderConfiguration.contactStyle;
      this.topHeaderTemplate = this.menuHeaderConfiguration.nameTemplate;
      this.topHeaderFontColor = '#' + this.menuHeaderConfiguration.fontColor;
    }
    /*PROVISIONAL FOR GALASKY*/
    this.renderTopHeaderOnlyResponsive = this.companyParamsService.getContactsLinksSectionHeaderResponsive();
    if (typeof window !== 'undefined') {
      this.isReponsive = window.innerWidth <= 1024;
      this.innerWidth = window.innerWidth;
    }
  }

  ngOnChange() {
    if (typeof window !== 'undefined') {
      this.isReponsive = window.innerWidth <= 1024;
    }
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

  getHeight(height: any) {
    this.headerHeightInput = height;
  }

  getHeight1(height: any) {
    this.headerHeightInput1 = height;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (typeof document === 'undefined') return;
      if (this.renderTopHeader) {
        if (this.isReponsive) {
          if (this.renderTopHeaderOnlyResponsive) {
            var height = this.headerRef.nativeElement.offsetHeight;
            this.headerHeight.emit(height);
            var height1 = this.headerRef1.nativeElement.offsetHeight;
            this.headerHeight1.emit(height1);
          } else {
            this.headerHeightInput = isNullOrUndefined(this.headerHeightInput) ? document.getElementById("nvbar")?.offsetHeight || 0 : this.headerHeightInput;
            this.headerHeight.emit(this.headerHeightInput);
            this.headerHeightInput1 = isNullOrUndefined(this.headerHeightInput1) ? document.getElementById("nvbar")?.offsetHeight || 0 : this.headerHeightInput1;
            this.headerHeight1.emit(this.headerHeightInput1);
          }
        } else {
          var height = this.headerRef.nativeElement.offsetHeight;
          this.headerHeight.emit(height);
          var height1 = this.headerRef1.nativeElement.offsetHeight;
          this.headerHeight1.emit(height1);
        }
      } else {
        this.headerHeightInput = isNullOrUndefined(this.headerHeightInput) ? document.getElementById("nvbar")?.offsetHeight || 0 : this.headerHeightInput;
        this.headerHeight.emit(this.headerHeightInput);
        this.headerHeightInput1 = isNullOrUndefined(this.headerHeightInput1) ? document.getElementById("nvbar")?.offsetHeight || 0 : this.headerHeightInput1;
        this.headerHeight1.emit(this.headerHeightInput1);
      }
    }, 500);
  }

  setCustomCSS(css: string): any {
    let q = (css != undefined && css != "") ? JSON.parse(css.replace("'", "").replace("'", "").trim()) : "";
    return q;
  }

  getTopHeaderBackgroundColor() {
    return this.topHeaderBackgroundColor;
  }

  getTopHeaderFontColor() {
    return this.topHeaderFontColor;
  }

  getTopHeaderHeight() {
    return this.topHeaderHeight;
  }

  getTopHeaderRRSSIcons() {
    return this.topHeaderRRSSIcons;
  }

  getTopHeaderContactIcons() {
    return this.topHeaderContactIcons;
  }

}
